export default {
  getLastActivitySavedAt(state) {
    return state.lastActivitySavedAt
  }
}
